import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"
import { patch as railsPatch } from "@rails/request.js"

// Each list sorts itself. Lists sharing a group (terms within a sequence, lessons
// across terms) can pass items between them; a drop PATCHes where it landed.
export default class extends Controller {
  connect() {
    this.sortable = new Sortable(this.element, {
      filter: ".disable-sorting",
      // Let clicks through to what can't be dragged, so inputs in a draggable item can be focused.
      preventOnFilter: false,
      group: this.element.dataset.sortableGroupValue,
      scrollSensitivity: 200,
      forceFallback: true,
      animation: 150,
      fallbackOnBody: true,
      swapThreshold: 0.3,
      onEnd: this.moved.bind(this),
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  async moved({ item, newIndex, to }) {
    const url = item.dataset.sortableUpdateUrl
    if (!url || !item.dataset.entryId) return

    const data = new FormData()
    data.append("entry_id", item.dataset.entryId)
    data.append("entry_type", item.dataset.entryType)
    data.append("container_id", to.dataset.containerId)
    data.append("container_type", to.dataset.containerType)
    data.append("position", newIndex + 1)

    // The page already shows the move, so a refused or lost one has to put the page back.
    try {
      const response = await railsPatch(url, { body: data, responseKind: "turbo-stream" })
      if (!response.ok) window.location.reload()
    } catch {
      window.location.reload()
    }
  }
}
